import { render, staticRenderFns } from "./MSelectStatus.vue?vue&type=template&id=296d1e67&"
import script from "./MSelectStatus.vue?vue&type=script&lang=js&"
export * from "./MSelectStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports